import VyomeshEp3Image from '../assets/images/vyomesh_ep3.webp'
import VyomeshEp2Image from '../assets/images/vyomesh_ep2.webp'
import VyomeshEp1Image from '../assets/images/vyomesh_ep1.webp'
import VikasEp3Image from '../assets/images/vikas_ep3.webp'
import VikasEp2Image from '../assets/images/vikas_ep2.webp'
import VikasEp1Image from '../assets/images/vikas_ep1.webp'

export const PODCAST_DATA = [
  {
    title: '#LifeKaFilter - Episode 3 | Vyomesh Kaul | Kidney Health | Zydus',
    date: '01 May 2025',
    image: VyomeshEp3Image,
    time: '38 min watch',
    videoKey: 'E_-yVJsULZk',
    statementTitle: 'Kidney Health Starts with Awareness',
    statementDescription:
      'Hear practical conversations and expert insights that help you understand CKD better and make informed choices for your long-term health.',
  },
  {
    title: '#LifeKaFilter - Episode 2 | Vyomesh Kaul | Kidney Health | Zydus',
    date: '25 Apr 2025',
    image: VyomeshEp2Image,
    time: '40 min watch',
    videoKey: '9OoY53Ngduk',
    statementTitle: 'Conversations that Build Confidence',
    statementDescription:
      'From diagnosis to day-to-day care, this episode shares practical stories that can help people living with CKD feel more prepared.',
  },
  {
    title: '#LifeKaFilter - Episode 1 | Vyomesh Kaul | Kidney Health | Zydus',
    date: '17 Apr 2025',
    image: VyomeshEp1Image,
    time: '44 min watch',
    videoKey: 'BOXB01O1LmU',
    statementTitle: 'Real Voices, Real CKD Journeys',
    statementDescription:
      'Listen to real patient and expert experiences that simplify kidney-care decisions and encourage healthier everyday routines.',
  },
  {
    title:
      '#LifeKaFilter - Episode 3 | Chef Vikas Khanna | Kidney Health | Zydus',
    date: '15 Apr 2025',
    image: VikasEp3Image,
    time: '35 min watch',
    videoKey: 'bXLqMedwz_I',
    statementTitle: 'Food Choices that Support Kidneys',
    statementDescription:
      'Chef-led guidance and practical nutrition tips to help CKD patients enjoy flavor while keeping kidney health in focus.',
  },
  {
    title:
      '#LifeKaFilter - Episode 2 | Chef Vikas Khanna | Kidney Health | Zydus',
    date: '28 March 2025',
    image: VikasEp2Image,
    time: '26 min watch',
    videoKey: 'MHSVDWZnXqQ',
    statementTitle: 'Healthy Habits Through Better Meals',
    statementDescription:
      'Discover approachable recipe ideas and mindful food swaps designed for people managing CKD every day.',
  },
  {
    title:
      '#LifeKaFilter - Episode 1 | Chef Vikas Khanna | Kidney Health | Zydus',
    date: '20 March 2025',
    image: VikasEp1Image,
    time: '48 min watch',
    videoKey: 'qnYpXHOVYY0',
    statementTitle: 'CKD Care with Everyday Simplicity',
    statementDescription:
      'This episode shares simple kitchen and lifestyle changes that can make CKD-friendly routines easier to maintain.',
  },
]
